import React from 'react'
import filter from 'ramda/src/filter'

export default ({ props: { value, MultiValue, input, onSelect, locked } }) => {
	const clearValue = (option) => {
		if (locked) return
		onSelect(filter(item => item.id !== option.id, value))
		const currentInput = input.current
		currentInput.value = ''
	}
	return value.map(item => (
		<MultiValue
			locked={locked}
			removeProps={{ onClick: clearValue }}
			key={item.value}
		>
			{ item }
		</MultiValue>
	))
}
